import React from 'react'

import Sticky from 'js/components/Sticky/Sticky'

import MenuWrapper from './styles/MenuWrapper'
import TabMenuItem from './TabMenuItem'

const TabMenu = ({
    edgePadding,
    edgeMargin,
    showBorder,
    sticky,
    options,
    TabElement,
    children,
    label,
    ...rest
}) => {
    if (!options || !options.length) {
        return null
    }

    return (
        <MenuWrapper
            $edgePadding={edgePadding}
            $edgeMargin={edgeMargin}
            $showBorder={showBorder}
            $sticky={sticky}
            as={sticky ? Sticky : null}
            {...rest}
        >
            <div className="MenuContainer" role="tablist" aria-label={label}>
                {options.map((item, i) => (
                    <TabMenuItem
                        key={i}
                        item={item}
                        counter={i}
                        TabElement={TabElement}
                    />
                ))}
                {children}
            </div>
        </MenuWrapper>
    )
}

export default TabMenu
